$(document).ready(function () {


    function resize($text) {
        $text.css('height', 'auto');
        $text.css('height', $text[0].scrollHeight + 'px');
    }

    if ($('.select2').length > 0) {
        $('.select2').select2({});
    }


    $(document).on('click', '.faq-item-title', function () {
        let _this = $(this),
            _block = _this.parent(),
            _content = _block.find('.faq-item-content');

        if (_block.hasClass('open')) {
            _content.slideUp(300, function () {
                _block.removeClass('open');
            })
        } else {
            _content.slideDown(300, function () {
                _block.addClass('open');
            })
        }
    });


    const swiperIndexReviews = new Swiper('.swiper-index-reviews', {
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
                // grid: {
                //     rows: 2,
                //     fill: 'column'
                // },
            },
        },
    });

    const swiperHow = new Swiper('.swiper-how', {
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        slidesPerView: 1,
        on: {
            slideChangeTransitionEnd: function (swiper) {
                sliderTabsChange($('.index-how-tabs li:nth-child(' + (swiper.activeIndex + 1) + ')'));
            }
        }
    });

    $(document).on('click', '.index-how-tabs li', function () {
        swiperHow.slideTo($(this).index());
    });

    function sliderTabsChange(_this) {
        let _block = _this.closest('ul'),
            _line = _block.find('span'),
            _active = _block.find('li.active');


        _line.animate({
            left: _this.position().left - _active.position().left,
            width: _this.outerWidth()
        }, 400, 'swing', function () {
            _this.append('<span></span>');
            _line.remove();
            _active.removeClass('active');
            _this.addClass('active');
        })
    }

    $(document).on('click', '.open-mobile-menu', function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
        } else {
            $(this).addClass('open');
            if ($('.mobile-menu-block').length > 0) {
            } else {
                $('header.header').append('' +
                    '<div class="mobile-menu-block" style="display: none;">' +
                    '<div class="mobile-menu-overlay"></div>' +
                    '<div class="mobile-menu-container">' +
                    '<button class="mobile-menu-close"><span></span><span></span></button>' +
                    '<div class="mobile-menu-content">' +
                    '<a href="/"><img src="' + $('#footer-logo').attr('src') + '" alt=""></a>' + $('#main-menu').html() +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '');
            }
            $('.mobile-menu-block').show();
            $('.mobile-menu-overlay').animate({
                opacity: 1
            }, 200, function () {
                $('.mobile-menu-container').animate({
                    left: '0px'
                }, 200);
            })
        }
    });

    if ($('#phone-input').length > 0) {
        var iti = window.intlTelInput(document.querySelector('#phone-input'), {
            initialCountry: 'auto',
            geoIpLookup: function (callback) {
                // $.get('https://ipinfo.io', function () {
                // }, 'jsonp').always(function (resp) {
                //     var countryCode = (resp && resp.country) ? resp.country : 'RU';
                //     $('#phone-input').focus();
                //     callback(countryCode);
                //
                // });

                let getNavigatorLanguage = () => {
                    if (navigator.languages && navigator.languages.length) {
                        return navigator.languages[0];
                    } else {
                        return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'ru';
                    }
                }

                getNavigatorLanguage = getNavigatorLanguage().split('-');

                callback(getNavigatorLanguage[0]);
            },
            nationalMode: false,
            formatOnDisplay: true,
            separateDialCode: true,
            autoPlaceholder: 'aggressive',
            preferredCountries: ["ru", "ua", "by", "kz"],
            // utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js',
        });

        $(document).on('countrychange', '#phone-input', function (q) {
            $('#phone-code').val(iti.getSelectedCountryData().dialCode);

            Inputmask({
                mask: intlTelInputUtils.getExampleNumber(iti.getSelectedCountryData().iso2, 0, 0).replace('+' + iti.getSelectedCountryData().dialCode, '').trim().replace(new RegExp('[0-9]', 'g'), '9'),
                placeholder: '_'
            }).mask(document.getElementById('phone-input'));
        });

    }

    if ($('.repeat-code').length > 0) {
        let minutes = ['минута', 'минуты', 'минут'],
            seconds = ['секунда', 'секунды', 'секунд'],
            startSeconds = $('.repeat-code').data('seconds'),
            min,
            sec,
            text = '',
            timer;

        smsCode(); // вызов функции
        function smsCode() {  // функция обратного отсчета

            text = '';
            //$('.repeat-code span').text(startSeconds + ' ' + endWords(startSeconds, seconds));

            if (startSeconds > 59) {
                min = Math.floor(startSeconds / 60);
                sec = startSeconds - (min * 60);
            } else {
                min = 0;
                sec = startSeconds;
            }

            if (min > 0) {
                text = text + min + ' ' + endWords(min, minutes) + ' ';
            }
            text = text + sec + ' ' + endWords(sec, seconds);

            $('.repeat-code span').text(text);
            $('.repeat-code').data('timer', startSeconds);
            startSeconds--; // уменьшаем число на единицу
            if (startSeconds < 0) {
                clearTimeout(timer); // таймер остановится на нуле
                $('.repeat-code a').text('Отправить еще раз');
            } else {
                timer = setTimeout(smsCode, 1000);
            }
        }

        $(document).on('click', '.repeat-code', function () {
            if ($(this).data('timer') > 0)
                return false;
        });
    }

    function endWords(num, words) {
        let original = num;

        num = num % 100;
        if (num > 19) {
            num = num % 10;
        }

        switch (num) {
            case 1:
                return words[0];
            case 2:
            case 3:
            case 4:
                return words[1];
            default:
                return words[2];
        }
    }

    $(document).on('click', '.mobile-menu-close, .mobile-menu-overlay', function () {
        $('.mobile-menu-container').animate({
            left: '-500px'
        }, 200, function () {
            $('.mobile-menu-overlay').animate({
                opacity: 0
            }, 200, function () {
                $('.mobile-menu-block').hide();
            });
        });
        $('.open-mobile-menu').removeClass('open');
    });

    const detectOS = function () {
        const platform = window.navigator.platform,
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            customScrollbarsClass = 'custom-scrollbars';

        // Add class if OS is windows
        windowsPlatforms.indexOf(platform) != -1 && $('body').addClass(customScrollbarsClass);
    };

    detectOS();

    $(".scroll-top-logo").on("click", function (e) {
        if ($(document).width() >= 992) {
            e.preventDefault();
            $('html, body').stop().animate({
                scrollTop: 0
            }, 800);
        }
    });

});